import WithdrawalAccount from './WithdrawalAccount';
import ContactSupport from './ContactSupport';
import InviteFriends from './InviteFriends';
import BusinessInfo from './BusinessInfo';
import Security from './Security';
import Settings from './Settings';
import Logout from './Logout';
import Kyc from './Kyc';
import Faqs from './Faqs';
import GeneralSettings from './GeneralSettings';
import ApiKeys from './ApiKeys';

export {
	BusinessInfo,
	Security,
	Settings,
	InviteFriends,
	Logout,
	ContactSupport,
	WithdrawalAccount,
	Kyc,
	Faqs,
	GeneralSettings,
	ApiKeys,
};
